import { render, staticRenderFns } from "./areaError404.vue?vue&type=template&id=98ff33e6&"
import script from "./areaError404.vue?vue&type=script&lang=js&"
export * from "./areaError404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports